/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { SignInService } from "../../auth-feature/authServices/signin.service";
import { Router } from "@angular/router";
import { ProductHomeService } from "../../product-feature/product-home/product-home.service";

@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.scss"],
})
export class EditProfileComponent implements OnInit {
  userEmailCheck = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  userPhoneCheck = /^[0-9]{10}$/;
  user = { email: "", phone: "", name: "" };
  userUpdate = { email: "", phone: "", name: "" };
  primary = { email: false, phone: false };
  userMessage = "";

  userEditForm = new FormGroup({
    userName: new FormControl({ value: "" }, [Validators.required]),
    userEmail: new FormControl({ value: "" }, [
      Validators.pattern(this.userEmailCheck),
    ]),
    userPhone: new FormControl({ value: "" }, [
      Validators.pattern(this.userPhoneCheck),
    ]),
  });
  constructor(
    private signInService: SignInService,
    private dialogEdit: MatDialogRef<EditProfileComponent>,
    private service: ProductHomeService,
    private router: Router
  ) {}

  ngOnInit() {
    this.signInService.changePasswordDataPass.subscribe(
      (data) => {
        console.log(data);
        if (data.email) {
          this.user.email = data.email;
        }
        if (data.phone) {
          this.user.phone = data.phone;
        }
        if (data.name) {
          this.user.name = data.name;
        }
      },
      (err) =>
        console.log("Error while passing data from previous screen" + err)
    );

    if (this.user.email !== "") {
      this.userEmail.disable();
      this.primary.email = true;
    }
    if (this.user.phone !== "") {
      this.userPhone.disable();
      this.primary.phone = true;
    }
    console.log(this.primary);
  }

  get userName() {
    return this.userEditForm.get("userName");
  }
  get userEmail() {
    return this.userEditForm.get("userEmail");
  }
  get userPhone() {
    return this.userEditForm.get("userPhone");
  }

  editDetails() {
    this.userUpdate.name = this.userName.value;
    this.userUpdate.email = this.userEmail.value;
    this.userUpdate.phone = this.userPhone.value;
    console.log(this.userUpdate);
    let request = {
      displayName: this.userUpdate.name,
      email: this.userUpdate.email,
      mobile: this.userUpdate.phone,
    };
    this.signInService.updateUserInfo(request).subscribe(
      (res: any) => {
        console.log(res);
        this.service.throwUpdatedUser.next({
          displayName: res.user.displayName,
          email: res.user.email,
          mobile: res.user.mobile,
        });
        this.userMessage = "updated successfully";
        setTimeout(() => {
          this.dialogEdit.close();
        }, 500);
      },
      (err) => {
        console.log(err);
      }
    );

    if (this.primary.email) {
      this.userUpdate.name = this.userName.value;
      this.userUpdate.phone = this.userPhone.value;
    }
    if (this.primary.phone) {
      this.userUpdate.name = this.userName.value;
      this.userUpdate.email = this.userEmail.value;
    }
    console.log(this.userUpdate);

    if (this.primary.email) {
      if (this.user.name === this.userName.value) {
        this.userUpdate.phone = this.userPhone.value;
      } else if (this.user.phone === this.userPhone.value) {
        this.userUpdate.name = this.userName.value;
      } else {
        this.userUpdate.name = this.userName.value;
        this.userUpdate.phone = this.userPhone.value;
      }
    }
    if (this.primary.phone) {
      if (this.user.name === this.userName.value) {
        this.userUpdate.email = this.userEmail.value;
      } else if (this.user.email === this.userEmail.value) {
        this.userUpdate.name = this.userName.value;
      } else {
        this.userUpdate.name = this.userName.value;
        this.userUpdate.email = this.userEmail.value;
      }
    }
    console.log(this.userUpdate);
  }
}
